// extracted by mini-css-extract-plugin
export var form = "form-module--form--7zhfo";
export var mathtest = "form-module--mathtest--DPls3";
export var button = "form-module--button--UNZ+V";
export var success = "form-module--success--PT+WM";
export var error = "form-module--error--3MJeB";
export var radioBtns = "form-module--radioBtns--2I5YS";